export default __webpack_public_path__ + "static/media/daiguren_light_bg.35cd9ce6.png";